<template>
  <v-app id="font" tabindex="1">
    <v-main class="pa-5">
      <v-row>
        <v-col
          cols="12"
          md="4"
          order="3"
          order-md="0"
          class="d-flex align-center justify-start"
          :class="{
            'justify-center':
              $vuetify.breakpoint.name == 'xs' ||
              $vuetify.breakpoint.name == 'sm',
          }"
          v-if="isLoggedIn"
        >
          <v-btn
            outlined
            small
            depressed
            @click="$router.push({ path: '/transactions' })"
            >Transactions</v-btn
          >
        </v-col>

        <v-col
          cols="12"
          :md="isLoggedIn ? 4 : 12"
          class="d-flex align-center justify-center"
        >
          <img
            class="logo"
            src="@/assets/logo.png"
            @click="$router.push({ path: '/' })"
          />
        </v-col>

        <v-col
          v-if="isLoggedIn"
          cols="12"
          md="4"
          class="d-flex align-center justify-end"
          :class="{
            'justify-center':
              $vuetify.breakpoint.name == 'xs' ||
              $vuetify.breakpoint.name == 'sm',
          }"
        >
          <v-alert dense color="primary" dark class="ma-0">
            <div class="d-flex align-center">
              <span class="body-2 mr-4">You are logged in as admin</span>
              <v-btn light x-small depressed @click="logout">Log out</v-btn>
            </div>
          </v-alert>
        </v-col>
      </v-row>

      <router-view v-if="!loader"></router-view>

      <div class="d-flex align-center justify-center mt-12 pt-12" v-else>
        <v-progress-circular
          indeterminate
          color="primary"
          size="55"
        ></v-progress-circular>
      </div>

      <v-snackbar
        v-model="snackbar.open"
        timeout="4000"
        :color="snackbar.status == 'success' ? 'undefined' : 'error'"
      >
        <div class="d-flex align-center justify-center">
          <p class="body-2 mb-0 mr-2">
            {{
              snackbar.status == "success"
                ? "Your team has successfully been registered!"
                : "Something went wrong. Please try again later."
            }}
          </p>
          <v-btn
            :color="snackbar.status == 'success' ? 'accent' : 'white'"
            icon
            text
            @click="closeSnackbar"
            >OK</v-btn
          >
        </div>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import firebase from "firebase/app";
import { db } from "@/db";

export default {
  data() {
    return {
      loader: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.isLoggedIn,
    }),
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set() {
        //just for not printing an error.
      },
    },
  },
  created() {
    if (!firebase.auth().currentUser) {
      this.loader = true;
    }

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (!this.isLoggedIn) {
          db.collection("admins")
            .doc(user.uid)
            .get()
            .then((res) => {
              if (!res.data()) {
                firebase.auth().signOut();
                this.setAuthState(false);
              }

              if (res.data().profileType != "admin") {
                firebase.auth().signOut();
                this.setAuthState(false);
              }

              this.loader = false;
              this.setAuthState(true);
            })
            .catch(() => {
              firebase.auth().signOut();
              this.loader = false;
              this.setAuthState(false);
            });
        }
      } else {
        this.loader = false;
        this.setAuthState(false);
      }
    });
  },
  methods: {
    ...mapMutations(["closeSnackbar", "setAuthState", "clearState"]),
    async logout() {
      await firebase.auth().signOut();
      this.setAuthState(false);
      this.clearState();
      this.$router.push({ path: "/first" });
    },
  },
};
</script>

<style lang="scss">
#font {
  position: relative;
  *:not(.v-icon),
  *:not(.v-icon)::before,
  *:not(.v-icon)::after {
    font-family: "Oswald", sans-serif !important;
  }
}

.wrapper {
  min-height: calc(100vh - 40px - 80.66px - 24px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.inner-wrapper {
  max-width: 800px;
}

.searchInput {
  min-width: 280px;
}

.logo {
  width: 264px;
  height: auto;
  cursor: pointer;
}

#panel {
  .v-expansion-panel-content__wrap {
    padding: 0px 12px 4px 12px;
  }
}

a {
  text-decoration: none;
}
</style>